// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__37eVt","question":"styles_question__fjS49","description":"styles_description__28FEe"};